import React from "react";
import { Box, FormControl, MenuItem, Pagination, Select, Typography, SelectChangeEvent } from "@mui/material";

interface CommonPaginationProps {
  count: number;
  page: number;
  onChange: (event: React.ChangeEvent<unknown>, value: number) => void;
  align?: "start" | "center" | "end";
  rowsPerPage?: number;
  onRowsPerPageChange?: (value: number) => void;
  totalItems?: number;
}

const CommonPagination: React.FC<CommonPaginationProps> = ({
  count,
  page,
  onChange,
  align = "start",
  rowsPerPage = 10,
  onRowsPerPageChange,
  totalItems = 0,
}) => {
  const handleRowsPerPageChange = (event: SelectChangeEvent<number>) => {
    const value = event.target.value as number;
    if (onRowsPerPageChange) {
      onRowsPerPageChange(value);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        justifyContent: { xs: "center", md: "start" },
        mt: 4,
        mb: 2,
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: align,
        }}
      >
        <Pagination
          count={count}
          page={page}
          onChange={onChange}
          sx={{
            '& .MuiPaginationItem-root': { bgcolor: '#F9F9F9' },
            '& .Mui-selected': { bgcolor: '#E7F3FD' }
          }}
          shape="rounded"
        />
      </Box>
      <FormControl sx={{ ml: 2 }}>
        <Select 
          value={rowsPerPage} 
          onChange={handleRowsPerPageChange}
          variant="outlined"
          sx={{
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: '#ACACAC',
            },
          }}
        >
          <MenuItem value={10}>10</MenuItem>
          <MenuItem value={20}>20</MenuItem>
          <MenuItem value={50}>50</MenuItem>
          <MenuItem value={100}>100</MenuItem>
        </Select>
      </FormControl>
      <Typography variant="body2" sx={{  ml: 2, color: '#ACACAC' , }}>
        กำลังแสดง {Math.min((page - 1) * rowsPerPage + 1, totalItems)} ถึง {Math.min(page * rowsPerPage, totalItems)} จาก {totalItems} รายการ
      </Typography>
    </Box>
  );
};

export default CommonPagination;
